import { render, staticRenderFns } from "./NewRoomLauncherBeforeStart.vue?vue&type=template&id=6046f5b1&"
import script from "./NewRoomLauncherBeforeStart.vue?vue&type=script&lang=js&"
export * from "./NewRoomLauncherBeforeStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports